// extracted by mini-css-extract-plugin
export default {"link":"link---q81Pm root---FBI0e","authorityLinkSpinner":"authorityLinkSpinner---zm5Kl"};